<template>
  <div class="col-sm-6 col-xs-12">
    <div class="box box--blue">
      <h2 class="box__title">{{ $t('boxes.visitors.title') }}</h2>
      <div class="collumns" :class="{ 'collumns--bordered': hasLocations() }">
        <div class="collumn">
          <h3 class="collumn__title">{{ $t('boxes.total') }}</h3>
          <span class="fz--large">{{ visitors.total }}</span>
        </div>
        <ul class="list collumn">
          <li class="list__item">
            <h3 class="list__title">{{ $t('boxes.visitors.unique') }}</h3>
            <div>{{ visitors.unique }} <span class="fz--small">{{ visitors.uniquePercentage }}%</span></div>
          </li>
          <li class="list__item" v-for="device in visitors.devices" :key="device.name">
            <h3 class="list__title">{{ device.name }}</h3>
            <div>{{ device.total }} <span class="fz--small">{{ device.percentage }}%</span></div>
          </li>
        </ul>
      </div>
      <table class="table table--simple table--highlight-first" v-show="hasLocations()">
        <tr class="title">
          <th>{{ $t('boxes.visitors.local') }}</th>
          <th>{{ $t('boxes.visitors.country') }}</th>
          <th>{{ $t('boxes.visitors.visits') }}</th>
        </tr>
        <tr class="item" v-for="location in visitors.locations" :key="location.id">
          <th>{{ location.city_name || $t('locations.not_identified') }}</th>
          <th>{{ location.country_name || $t('locations.not_identified') }}</th>
          <th>{{ location.visits }}</th>
        </tr>
      </table>
      <router-link class="button button--small--blue" :to="{ name: 'Locations', params: { locale: i18n.locale, pageIdentifier: $route.params.pageIdentifier }}"  v-show="hasLocations()">
        {{ $t('boxes.visitors.showMap') }}
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import i18n from '../../../../i18n';

export default {
  data() {
    return {
      i18n,
    };
  },
  computed: mapGetters({
    visitors: 'metrics/visitors',
  }),
  methods: {
    hasLocations() {
      return this.visitors.locations && this.visitors.locations.length > 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/screens/Metrics/components/boxes/Visitors.vue